import { useLocaleStore } from './../utils/localeStore'
import { useLanguage } from './../components/localization/LanguageContext'
const setLocale = locale => {
  useLocaleStore.setState({ locale: process.env.GATSBY_CURRENT_BUILD || 'de' })
}

/**
 * Returns the current selected language
 * @returns string ("de" or "at")
 */
const getLocale = () => {
  const { locale } = useLocaleStore(state => state)
  return locale || process.env.GATSBY_CURRENT_BUILD || 'de'
}

/**
 * Returns a path where the locale in the middle is removed and
 * is prefixed instead
 *
 * @param {*} path
 * @returns path
 */
const getCleanedPath = (locale, path) => {
  if (path && locale) {
    if (!locale) locale = getLocale()
    let newPath = path

    if (locale == 'de') {
      if (path.includes('/de/')) {
        newPath = path.replace('/de', '')
      }
      return newPath
    }
    if (locale == 'at') {
      if (path.includes('/at/')) {
        newPath = path.replace('/at', '')
      }
    }
    return newPath
  }
  return path?.replace('//', '') || '/'
}

/**
 * Returns stored marketurl if market in country else change country
 *
 * @param {*} url The url for main pages
 * @returns The path to the page in current selected language
 */
const getLocaleMarketUrl = (locale, marketCountry, url) => {
  const codes = ['de', 'at']
  marketCountry = marketCountry.toLowerCase()
  const currentBuild = process.env.GATSBY_CURRENT_BUILD || 'de'
  if (codes.indexOf(marketCountry) >= 0) {
    // TODO wenn auf anderem land als der gewählte dann url und absoluter Pfad

    //   // gewählter markt
    //   if (locale !== marketCountry.toLowerCase()) {
    //     // markt in anderem land als der gewählte
    //     return `${
    //       '/' + marketCountry.toLowerCase() + url.replace('/' + locale, '')
    //     }`
    //   } else {
    //     // markt im gewählten land
    //     return `${'/' + locale + url.replace('/' + locale, '')}`
    //   }
    // } else {
    //   //kein gewählter markt
    //   return `${'/' + locale + url.replace('/' + locale, '')}`
    let adjustedUrl = url.replace(new RegExp(`/${locale}/`, 'g'), '/')

    adjustedUrl = adjustedUrl.replace(new RegExp(`/${locale}/`, 'g'), '/')

    if (marketCountry != currentBuild) {
      return `${
        process.env.GATSBY_FOREIGN_URL || 'https://denns-biomarkt.at'
      }${adjustedUrl}`
    } else {
      return `${adjustedUrl}`
    }
  }
  return url
}

/**
 * Returns a given url prefixed with the current selected language
 *
 * @param {*} url The url for main pages
 * @returns The path to the page in current selected language
 */
const getLocaleUrl = (locale, url) => {
  // TODO wenn karriere At und auf DE , dann return atDomain + Pfad und umgekehrt

  // console.log(url)
  // // return `${locale == 'at' ? '/at' + url : '/de' + url}`
  // const ret = `${
  //   // '/' + locale + url.replace(`/${locale}/`, locale).replace('/' + locale, '')
  //   '/' + locale + url.replace('/' + locale, '')
  // }`

  // const ret = url?.replace(new RegExp(`^/${locale}/`), '/') || ''

  let ret = url?.replace(new RegExp(`^/${locale}/`), '/') || ''
  ret = ret.replace(new RegExp(`/${locale}/`, 'g'), '/')
  return ret.toLowerCase()
}

/**
 * Returns a complete Pathname in the current selected language
 * based on the pagecontext
 *
 * @param {*} lng
 * @returns
 */
// const getPathnameFromContext = lng => {
//   const { translations } = useLanguage()

//   let ret = [
//     translations[lng]?.basePath,
//     translations[lng]?.hasOwnProperty('category')
//       ? translations[lng].category
//       : '',
//     translations[lng]?.slug
//   ]
//     .filter(element => {
//       return element != '' && element != '//'
//     })
//     .join('/')
//     .replace('//', '/')
//   return ret.toLocaleLowerCase().includes(`/${lng}`)
//     ? ret.toLocaleLowerCase().replace(`${lng}`, '')
//     : ret.toLocaleLowerCase()

//   return translations.mainSlug || translations[lng]?.basePath || '/'
// }

export {
  setLocale,
  getLocale,
  getCleanedPath,
  getLocaleUrl,
  getLocaleMarketUrl
  // getPathnameFromContext
}
